import { Edit3, Plus, Power } from 'lucide-react';
import ActionButton from '../../../../components/Buttons/ActionButton';
import IconButton from '../../../../components/Buttons/IconButton';
import { RestaurantDiningRoomDTO } from '../../../../types/restaurant/RestaurantDiningRoomTypes';

interface DiningRoomTableProps {
  rooms: RestaurantDiningRoomDTO[];
  onEdit: (room: RestaurantDiningRoomDTO) => void;
  onDeactivate: (room: RestaurantDiningRoomDTO) => void;
  onAddTable: (room: RestaurantDiningRoomDTO) => void;
}

const updatedAt = (value: string) =>
  new Intl.DateTimeFormat('es-SV', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));

const DiningRoomTable = ({
  rooms,
  onEdit,
  onDeactivate,
  onAddTable,
}: DiningRoomTableProps) => (
  <div className="hidden overflow-x-auto md:block">
    <table className="w-full min-w-[880px] table-auto">
      <thead>
        <tr className="border-b border-stroke bg-gray-2/60 text-left text-xs font-semibold uppercase tracking-wide text-bodydark2 dark:border-strokedark dark:bg-meta-4/30">
          <th className="px-5 py-4 text-center">Orden</th>
          <th className="px-5 py-4">Nombre</th>
          <th className="px-5 py-4">Descripción</th>
          <th className="px-5 py-4">Estado</th>
          <th className="px-5 py-4">Fecha de actualización</th>
          <th className="px-5 py-4 text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {rooms.map((room) => (
          <tr
            key={room.id}
            className={`border-b border-stroke last:border-0 dark:border-strokedark ${
              room.active ? '' : 'opacity-65'
            }`}
          >
            <td className="px-5 py-4 text-center font-semibold text-black dark:text-white">
              {room.displayOrder}
            </td>
            <td className="px-5 py-4 font-medium text-black dark:text-white">
              {room.name}
            </td>
            <td className="max-w-sm px-5 py-4 text-sm text-bodydark2">
              <span className="line-clamp-2">
                {room.description || 'Sin descripción'}
              </span>
            </td>
            <td className="px-5 py-4">
              <span
                className={`rounded-full border px-2.5 py-1 text-xs font-medium ${
                  room.active
                    ? 'border-success/20 bg-success/10 text-success'
                    : 'border-danger/20 bg-danger/10 text-danger'
                }`}
              >
                {room.active ? 'Activo' : 'Inactivo'}
              </span>
            </td>
            <td className="whitespace-nowrap px-5 py-4 text-sm text-bodydark2">
              {updatedAt(room.updatedAt)}
            </td>
            <td className="px-5 py-4">
              <div className="flex justify-end gap-2">
                {room.active && (
                  <ActionButton
                    label="Mesa"
                    icon={<Plus size={16} />}
                    variant="outline"
                    size="sm"
                    fullWidth={false}
                    onClick={() => onAddTable(room)}
                  />
                )}
                <ActionButton
                  label="Editar"
                  icon={<Edit3 size={16} />}
                  variant="secondary"
                  size="sm"
                  fullWidth={false}
                  onClick={() => onEdit(room)}
                />
                {room.active && (
                  <IconButton
                    icon={<Power size={16} />}
                    variant="danger"
                    size="sm"
                    title="Desactivar salón"
                    onClick={() => onDeactivate(room)}
                  />
                )}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DiningRoomTable;
